import GenerateCampaignFormMeta from "../../Platforms/Meta/GenerateCampaign/GenerateCampaignFormMeta";
import GenerateCampaignFormGoogle from "../../Platforms/Google/GenerateCampaign/GenerateCampaignFormGoogle";
import GenerateCampaignFormTikTok from "../../Platforms/TikTok/GenerateCampaign/GenerateCampaignFormTikTok";
import GenerateCampaignFormLinkedin from "../../Platforms/Linkedin/GenerateCampaign/GenerateCampaignFormLinkedin";
import { GOOGLE, LINKEDIN, META, TIKTOK } from "../../../utils/constants";

const PLATFORM_GENERATE_FORMS = {
  [META]: GenerateCampaignFormMeta,
  [GOOGLE]: GenerateCampaignFormGoogle,
  [TIKTOK]: GenerateCampaignFormTikTok,
  [LINKEDIN]: GenerateCampaignFormLinkedin,
};

const CreateCampaignPlatformFlow = ({
  platform,
  campaignID,
  context,
  initialData,
  galleryHydrationRef,
  onCallbackSave,
  onExitToPlatformSelection,
  verifyBlockAlert = true,
  resumeValues = null,
}) => {
  const PlatformForm = PLATFORM_GENERATE_FORMS[platform];
  if (!PlatformForm) {
    return null;
  }

  return (
    <PlatformForm
      key={platform}
      initialData={initialData}
      campaignID={campaignID}
      generatedPlatforms={{}}
      context={context}
      galleryHydrationRef={galleryHydrationRef}
      onCallbackSave={onCallbackSave}
      onExitToPlatformSelection={onExitToPlatformSelection}
      verifyBlockAlert={verifyBlockAlert}
      resumeValues={resumeValues}
    />
  );
};

export default CreateCampaignPlatformFlow;
